<template>
  <div class="email-page">
    <h1 class="page-title">TODAY</h1>
    
    <TaskHeader/>

    <div class="view">
      <b-row>
        <Filters
          v-if="this.loaded === true"
          :filter="filter"
          :passedTasks="tasks"
          :openTask="openTask"
          :compose="changeCompose"
        />

        <div class="col-lg-9 col-xl-10 col-xs-12">

          <!-- <div v-show="this.loading" class="loader">Saving...</div> -->
          
          <!-- <i v-show="this.loading" class="fa fa-spinner"/> -->

          <div v-show="this.loading" class="loader animated fadeIn handle">
            <span class="spinner">
              <i class="fa fa-spinner fa-spin" />
            </span>
          </div>
            <b-alert 
                    :show="this.dismissSuccessCountDown"
                    dismissible
                    fade
                    variant="success"
                    @dismissed="setDismissSuccessCountDown(0)"
                    @dismiss-count-down="successCountDownChanged"
              >
              {{alertMessage}}
            </b-alert>
            <b-alert 
                    :show="this.errored"
                    dismissible
                    fade
                    variant="danger"
              >
              {{this.alertMessage}}
            </b-alert>
          <Compose v-if="this.$route.name === 'YourTasks'"/>
          <router-view v-if="this.tasks.length > 0" :passedTasks="this.tasks"></router-view>
        </div>

        <!--
        <OverdueRecallTable
          :filter="filterValue"
          :openedTask="openedTask"
          :openTask="openTask"
          :compose="compose"
          :changeCompose="changeCompose"
          :composeData="composeData"
          :visible="this.$store.state.visibleTaskComponent === 'OVERDUE_RECALL'"
        />

        <BrokenAppointmentsTable
          :filter="filterValue"
          :openedTask="openedTask"
          :openTask="openTask"
          :compose="compose"
          :changeCompose="changeCompose"
          :composeData="composeData"
          :visible="this.$store.state.visibleTaskComponent === 'BROKEN_APPOINTMENTS'"
        />

        <UnscheduledTreatmentTable
          :filter="filterValue"
          :openedTask="openedTask"
          :openTask="openTask"
          :compose="compose"
          :changeCompose="changeCompose"
          :composeData="composeData"
          :visible="this.$store.state.visibleTaskComponent === 'UNSCHEDULED_TREATMENT'"
        />

        <BaseTable
          :filter="filterValue"
          :openedTask="openedTask"
          :openTask="openTask"
          :compose="compose"
          :changeCompose="changeCompose"
          :composeData="composeData"
          :visible="this.$store.state.visibleTaskComponent === 'INCOMPLETE' || this.$store.state.visibleTaskComponent === 'DAILY_ROUTINE' || this.$store.state.visibleTaskComponent === 'MONTHLY_ROUTINE'"
        />
        -->

        
      </b-row>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import Vue from 'vue';
import $ from 'jquery';

import 'imports-loader?window.jQuery=jquery,this=>window!jquery-ui/ui/widgets/sortable'; //eslint-disable-line
import 'imports-loader?window.jQuery=jquery,this=>window!widgster'; // eslint-disable-line
import 'imports-loader?jQuery=jquery,this=>window!easy-pie-chart/dist/jquery.easypiechart.js'; // eslint-disable-line

import { mapState, mapActions } from 'vuex'

import TaskHeader from './components/TaskHeader/TaskHeader';
import Filters from './components/Filters/Filters';
import Compose from './components/Compose/Compose';
import TaskTable from './components/TaskTable/TaskTable';
import BaseTable from './components/BaseTable/BaseTable';

export default {
  name: 'Home',
  components: { TaskHeader, Filters, Compose, BaseTable, TaskTable },
  data() {
    return {
      isNotificationOpen: true,
      filterValue: null,
      openedTask: null,
      compose: false,
      composeData: null,
      alertAfter: false,
    };
  },

  async created() {
      await this.init();
  },

  mounted() {
    this.initCharts();
  },

  methods: {
    ...mapActions('tasks', ['getTasks']),
    ...mapActions('alert', ['setDismissSuccessCountDown', 'setMessage', 'setErrored']),
    ...mapActions('customer', ['getSites']),

    async init() {
      await this.getTasks({ employeeID: this.userID });
      if(this.isEmpty(this.settings)) {
        //console.log('getting settings from API');
        this.getSites({ customerID: this.customerID});
      }
    },

    isEmpty(obj) {
      for(var key in obj) {
          if(obj.hasOwnProperty(key))
              return false;
      }
      return true;
    },

    initCharts() { // eslint-disable-line
      $('#easy-pie1').easyPieChart({
        barColor: '#8fe5d4',
        trackColor: '#f8f9fa',
        scaleColor: false,
        lineWidth: 10,
        size: 120,
      });

      $('#easy-pie2').easyPieChart({
        barColor: '#ffd7de',
        trackColor: '#f8f9fa',
        scaleColor: '#f55d5d',
        lineCap: 'butt',
        lineWidth: 22,
        size: 140,
        animate: 1000,
      });

      $('#easy-pie3').easyPieChart({
        barColor: '#ffebb2',
        trackColor: '#f8f9fa',
        scaleColor: '#ffc247',
        lineCap: 'butt',
        lineWidth: 22,
        size: 140,
        animate: 1000,
      });

      $('#easy-pie4').easyPieChart({
        barColor: '#b7b3ff',
        trackColor: false,
        scaleColor: '#6c757d',
        lineCap: 'square',
        lineWidth: 10,
        size: 120,
        animate: 1000,
      });
    },
    fixAlert() {
      Vue.set(this, 'alertAfter', true);
    },
    filter(filterValue) {
      Vue.set(this, 'filterValue', filterValue);
      Vue.set(this, 'compose', false);
      Vue.set(this, 'composeData', null);
    },
    closeNotification() {
      Vue.set(this, 'isNotificationOpen', false);
    },
    openTask(id) {
      Vue.set(this, 'openedTask', id);
      Vue.set(this, 'compose', id === null ? false : this.compose);
      Vue.set(this, 'composeData', id === null ? null : this.composeData);
    },
    changeCompose(compose, data) {
      Vue.set(this, 'compose', compose);

      if (data) {
        Vue.set(this, 'composeData', data);
      }
    },
    successCountDownChanged(count) {
        this.setDismissSuccessCountDown(count);
    },
  },
  
  computed: {
    ...mapState({
        loading: state => state.alert.loading,
        loaded: state => state.alert.loaded,
        errored: state => state.alert.errored,
        alertMessage: state => state.alert.message,
        dismissSuccessCountDown : state => state.alert.dismissSuccessCountDown,
        userID: state => state.customer.userID,
        customerID: state => state.customer.customerID,
        settings: state => state.customer.settings,
        tasks: state => state.tasks.tasks,

    }),
  }
};
</script>

<style src="./Home.scss" lang="scss" scoped />
